import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentofdividentService } from 'src/app/services/paymentofdivident.service';
declare var $: any;

@Component({
  selector: 'app-paymentof-divident-list',
  templateUrl: './paymentof-divident-list.component.html',
  styleUrls: ['./paymentof-divident-list.component.css']
})
export class PaymentofDividentListComponent implements OnInit {
  isSearchDivVisible = false;
  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfPaymentOfDividend: DataTables.Settings = {};
  registerDirectorList: any[];
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerPaymentOfDividend: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  response: boolean;
  deletePodId: any;
  nameOfMember: any;
  editPaymentID: any;
  dateOfDeclaration: any;
  dateOfDeclarationTo: any;

  constructor(private PaymentOfDividendService: PaymentofdividentService, private router: Router, 
    private alert: AlertComponent,private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {

    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');
    this.dtOptionsOfPaymentOfDividend = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [14] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Payment Of Dividend',
          title: 'Payment Of Dividend',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 4, 6, 7, 9, 10, 11, 13],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };
    // $("#paymentOfDividentTable").DataTable().columns.adjust().draw();
    this.getPaymentOfDividendList();

  }

  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['paymentOfDividend','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  // loadDetailsById(directorId) {
  //   this.router.navigate(['/intern/edit/', directorId]);
  // }

  adjustdirectormasterTable() {
    var directorData = this.registerDirectorList;
    if (directorData.length) {
      this.registerDirectorList = [];
      $("#paymentOfDividentTable").DataTable().destroy();
      this.registerDirectorList = directorData;

      this.dtTriggerPaymentOfDividend.next();
      // setTimeout(() => {
      //   $("#paymentOfDividentTable").DataTable().columns.adjust().draw();
      // }, 200);
    }
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#paymentOfDividentTable").DataTable().columns.adjust().draw();
    });
  }


  getPaymentOfDividendList() {

    this.registerDirectorList = [];
    this.PaymentOfDividendService.getRegisterDirector({ isSearch: false }).subscribe(registerList => {
       
      $("#paymentOfDividentTable").DataTable().destroy();
      this.registerDirectorList = registerList.data;
      this.dtTriggerPaymentOfDividend.next();
      // setTimeout(() => {
      //   this.dtTriggerPaymentOfDividend.next();
      // }, 200);
    });
  }

  loadPaymentDataById(paymentOfDividendId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['paymentOfDividend','edit',paymentOfDividendId]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['/paymentofdividend/edit', paymentOfDividendId]);
  }

  confirmDelete(id) {
    this.deletePodId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deletePaymentOfDividenddetail() {
    this.PaymentOfDividendService.removePaymentOfDividenddetails(this.deletePodId)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#paymentOfDividentTable").DataTable().destroy();
          $("#deleteConfirm").modal('toggle');
        } else {
          this.alert.error(response.message);
        }
        this.getPaymentOfDividendList();

      });

  }

  editPaymentdetail(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['paymentOfDividend','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['paymentOfDividend/edit/', _id]);
  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfDeclaration,
      toDate: this.dateOfDeclarationTo,
      name: this.nameOfMember
    }
    this.PaymentOfDividendService.generatePaymentOfDividendDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.PaymentOfDividendService.downloadPaymentOfDividendFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.PaymentOfDividendService.downloadPaymentOfDividendPdfFile(id, 'Multi');
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "nameOfMember": this.nameOfMember,
      "dateOfDeclaration": this.setDate(this.dateOfDeclaration),
      "dateOfDeclarationTo": this.setDate(this.dateOfDeclarationTo),
      'isSearch': true,
    };
    this.registerDirectorList = [];
    $("#paymentOfDividentTable").DataTable().destroy();
    this.PaymentOfDividendService.getRegisterDirector(searchParam).subscribe(registerList => {
      this.response = false;
      this.registerDirectorList = registerList.data;
      this.dtTriggerPaymentOfDividend.next();
    });
  }
  clearAdvSearch() {
    this.nameOfMember = '';
    this.dateOfDeclaration = undefined;
    this.dateOfDeclarationTo = undefined;
    $("#paymentOfDividentTable").DataTable().destroy();
    this.getPaymentOfDividendList();
  }

}
